import React from 'react'
import PropTypes from 'prop-types'
import flow from 'lodash/flow'
import { withRouter } from 'react-router'
import { NavDropdown, MenuItem } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'

class NavSetup extends React.Component {
  render() {
    const { apps, user } = this.props
    if (!apps || !apps.admin || user.auth > 0) return null

    return (
      <NavDropdown title='Setup' id='nav-admin'>
        {
          apps.admin.map( (item, i) => (
            <LinkContainer key={i} to={item.alias} activeClassName='active'>
              <MenuItem>
                <span className='px-nav-icon'><item.icon size={12}/></span>
                {item.name}
              </MenuItem>
            </LinkContainer>
          ))
        }
      </NavDropdown>
    )
  }
}

NavSetup.propTypes = {
  strings: PropTypes.object,
  apps: PropTypes.object,
  user: PropTypes.object,
}

const decorators = flow([
  withRouter
])

export default decorators(NavSetup)



// WEBPACK FOOTER //
// ./src/components/nav/NavSetup.js